import React, { useMemo, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
  HvTableColumnConfig,
  useHvTable,
} from "@hitachivantara/uikit-react-lab";

import SimpleTable, {
  numberColumn,
  switchColumn,
  tagColumn,
  textColumn,
} from "components/common/SimpleTable";

import { populateMasterData, Status, useStatus } from "lib/api";

const IncidentStatusTable: React.FC = () => {
  const { t } = useTranslation("incidentStatus");
  const { data, mutate } = useStatus();

  useEffect(() => {
    if (data && data.data && data.data.length === 0) {
      (async () => {
        await populateMasterData();
        await mutate();
      })();
    }
  }, [data, mutate]);

  const columns = useMemo(
    (): HvTableColumnConfig<Status>[] => [
      numberColumn({
        Header: t("columns.order") as string,
        accessor: "status_order",
        style: { width: 100 },
      }),
      tagColumn(
        {
          Header: t("columns.name") as string,
          accessor: "status_name",
          style: { width: "20%" },
        },
        "status_name",
        "status_color",
        "status_text_color",
        true
      ),
      switchColumn(
        {
          Header: t("columns.default") as string,
          accessor: "status_is_default",
          style: { width: 180 },
        },
        t("columns.default"),
        t("labels.no"),
        t("labels.yes")
      ),
      textColumn({
        Header: t("columns.type") as string,
        accessor: "inc_status_type",
      }),
    ],
    [t]
  );

  const instance = useHvTable<Status>({
    columns,
    data: data?.data || [],
    getRowId: useCallback((v: Status): string => `${v.pk_status_id}`, []),
  });

  return data ? (
    <SimpleTable
      instance={instance}
      totalCount={data?.totalCount}
      disableSelection
      disablePagination
    />
  ) : null;
};

export default IncidentStatusTable;
